import React from 'react'
import ReactDOM from 'react-dom/client'
import { HashRouter } from 'react-router-dom';
import{ default as ConfigRoutes} from '@/router/index.jsx';
// import Tab from '@/components/Tab';


// import App from './App.jsx'
// import 'antd/dist/antd.css';
// import reportWebVitals from './reportWebVitals';

import { store } from '@/stores/'
import { Provider } from 'react-redux'

import './styles/common.css';


ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <Provider store={store}>
        <HashRouter>
          {/* <Tab></Tab> */}
          <ConfigRoutes />
        </HashRouter>

    </Provider>
  </React.StrictMode>,
)

// // If you want to start measuring performance in your app, pass a function
// // to log results (for example: reportWebVitals(console.log))
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
